<template>
  <div class="qs-departure-input" :class="[{'qs-departure-input--half':half},{'qs-departure-input--full':full}]">
    <input type="text" v-model="search" :placeholder="$t(currentIbe.translation_key + translationPrefix + 'label')">
  </div>
</template>

<script>

  import currentSelectionMixin from '../../mixins/currentSelectionMixin'
  import ibeDataMixin from '../../mixins/ibeDataMixin'

  export default {
    name: 'QsDepartureInput',
    mixins: [currentSelectionMixin, ibeDataMixin],
    props: {
      full: {
        type: Boolean,
        default: false
      },
      half: {
        type: Boolean,
        default: false
      },
      translationPrefix: {
        type: String,
        default: '.departure_airports.'
      }
    },
    data () {
      return {
        search: ''
      }
    },
    watch: {
      currentIbe () {
        this.search = ''
      },
      search () {
        this.setDepartureUserInput(this.search)
      }
    }
  }
</script>

<style lang="scss">
  @import "QsDepartureInput";
</style>
